import { createFileRoute } from '@tanstack/react-router';

import RfidAssignment from '@/ui/pages/RfidAssignment/RfidAssignment';

export interface RfidAssignmentSearch {
  readonly sessionId?: string | undefined;
  readonly institutionId?: string | undefined;
  /** @deprecated Legacy spelling of `institutionId`; see utils/activationSearch.ts. */
  readonly tenantId?: string | undefined;
}

// Public route (no auth guard): a device deep-links here as
// /rfid-assignment?sessionId=…&institutionId=… to bind an RFID card to a user.
// `tenantId` is the legacy spelling of the same value and stays accepted while devices roll over.
export const Route = createFileRoute('/rfid-assignment')({
  validateSearch: (search: Record<string, unknown>): RfidAssignmentSearch => ({
    sessionId: typeof search.sessionId === 'string' ? search.sessionId : undefined,
    institutionId: typeof search.institutionId === 'string' ? search.institutionId : undefined,
    tenantId: typeof search.tenantId === 'string' ? search.tenantId : undefined,
  }),
  component: RfidAssignment,
});
